export default __webpack_public_path__ + "static/media/article.579ef87b.png";